import { createReducer, on } from '@ngrx/store';
import { CreditInfo, StoreProfile } from '../../core/models';
import { AuthActions } from '../auth/auth.actions';
import { OrdersActions } from '../orders/orders.actions';
import { ProfileActions } from './profile.actions';

export interface ProfileState {
  profile: StoreProfile | null;
  loading: boolean;
  loaded: boolean;
  error: string | null;
  credit: CreditInfo | null;
  creditLoading: boolean;
  creditLoaded: boolean;
  creditError: string | null;
}

export const initialProfileState: ProfileState = {
  profile: null,
  loading: false,
  loaded: false,
  error: null,
  credit: null,
  creditLoading: false,
  creditLoaded: false,
  creditError: null,
};

export const profileReducer = createReducer(
  initialProfileState,

  on(ProfileActions.loadProfile, (state) => ({ ...state, loading: true, error: null })),
  on(ProfileActions.loadProfileSuccess, (state, { profile }) => ({
    ...state,
    profile,
    loading: false,
    loaded: true,
  })),
  on(ProfileActions.loadProfileFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(ProfileActions.loadCreditInfo, (state) => ({
    ...state,
    creditLoading: true,
    creditError: null,
  })),
  on(ProfileActions.loadCreditInfoSuccess, (state, { credit }) => ({
    ...state,
    credit,
    creditLoading: false,
    creditLoaded: true,
  })),
  on(ProfileActions.loadCreditInfoFailure, (state, { error }) => ({
    ...state,
    creditLoading: false,
    creditError: error,
  })),

  // A placed order consumes credit — the profile slice reacts to the same
  // success action the orders slice does.
  on(OrdersActions.placeOrderSuccess, (state, { order }) =>
    state.credit
      ? {
          ...state,
          credit: {
            ...state.credit,
            usedCreditLimit: state.credit.usedCreditLimit + order.total,
            availableCredit: Math.max(0, state.credit.availableCredit - order.total),
          },
        }
      : state,
  ),

  on(AuthActions.logout, () => initialProfileState),
);
